import {APIENDPOINT} from '../constants';
var APIURL = window.bookingsUrl + APIENDPOINT;

export default {
  init() {
    var AUTH = window.AUTH;
    $('.event-slider').slick({
      prevArrow: $('.event-slider-prev-button'),
      nextArrow: $('.event-slider-next-button'),
      dots: $(window).width() < 800,
    });

    if ($('.my-bookings').length > 0) {
      var data = $.ajax({
        url: APIURL + 'users/me',
        method: 'GET',
        beforeSend: function (req) {
          req.setRequestHeader('Authorization', AUTH);
        },
        success: function (response) {
          var $bookings = $('.my-bookings');

          var mybookings = response._embedded.bookings;
          var html = "";
          if(mybookings.length>0){
            $('.upcoming-activities').show();
          }
          for(var i = 0; i < mybookings.length; i++){
            var booking = mybookings[i];
            var url = HOME_URL + '/bookings/'+booking.id;
            var date = new Date(booking.from);
            var toDate = new Date(booking.to);
            var monthNames = [
              "Jan", "Feb", "Mar",
              "Apr", "May", "Jun", "Jul",
              "Aug", "Sep", "Oct",
              "Nov", "Dec"
            ];
            var month = monthNames[date.getMonth()];
            var day = date.getDate();
            var from = (date.getHours()<10?'0':'')+date.getHours()+':'+(date.getMinutes()<10?'0':'')+date.getMinutes();

            var to = (toDate.getHours()<10?'0':'')+toDate.getHours()+':'+(toDate.getMinutes()<10?'0':'')+toDate.getMinutes();
            html += `

            <a href="${url}" class="md:w-1/2 py-3 px-2 no-underline">
					    <div class="border-white border-2 h-48 flex rounded-lg">
						    <div class="flex flex-col w-2/3 text-left p-6 justify-around">
							      <p class="text-lg font-light">ROOM BOOKING</p>
							      <h4 class="text-2xl md:text-3xl">${booking.roomName}</h4>
							      <p class="text-lg font-light">Passcode: ${booking.roomDoorCode}</p>
						    </div>
						    <div class="flex flex-col border-l-2 border-white w-1/3 pb-1 justify-center items-center">
                  <p class="bold text-xl alschlange">${month}</p>
                  <p class="bold text-5xl alschlange">${day}</p>
                  <p class="pt-4 font-light text-lg">${from}-${to}</p>
						    </div>
					    </div>
				    </a>

            `
          }
          var $bookings = $('.my-bookings');
          $bookings.html(html);
        }, error: function (error) {
          console.log("error", error);
        }
      });

    }
  }
};
